import React from 'react';
import Login from './login';
import { UserLoginDTO } from '../../../Models/Login';
import { useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import AuthContext from '../../store/authContext';

const LoginWrapper: React.FC = () => {
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);

  const onLogin = async (loginData: UserLoginDTO) => {
    const success = await login(loginData);
    if (success) {
      navigate('/');
    }
  };

  return <Login onLogin={onLogin} />;
};

export default LoginWrapper;